/**
 * @desc 配置文件
 * @auth Vman
 */

let config = {
    sdk: 'NIM_Web_SDK_v6.1.0',
    useDb:true,
    defaultUserIcon: require('../assets/images/defaultIcon.jpg'),
    defaultUserPatientsIcon: require('../assets/images/defaultIcon_patients.png'),
    localMsglimit:'',
    loginUrl:'',
    registUrl:'',
    ImageUrl: 'https://static.doctor.uat.lejian.com/',
}

const env = 'production'
let appConfig = {
    // 用户的appkey
    // 用于在web demo中注册账号异步请求demo 服务器中使用
    online: {
        appkey: '2e37a19eba9981c93a0c7ccb44f96575',
        postUrl: 'https://app.netease.im'
    },
    production:{
        appkey: '2e37a19eba9981c93a0c7ccb44f96575',
        postUrl: 'https://app.netease.im'
    }
}

config = Object.assign(config, appConfig[env])

export default config